import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const getCsrfToken = () => {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'csrf_access_token') {
        return value;
      }
    }
    return null;
};

// Create axios instance with default config
const api = axios.create({
  baseURL: apiUrl + 'api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add interceptor to set CSRF token on each request
api.interceptors.request.use(config => {
  config.headers['X-CSRF-Token'] = getCsrfToken();
  return config;
});

export default api;